import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ChatHistory {
    is_user: boolean;
    message: string;
    chatId: string;
}

interface ChatHistoryState {
    [chatId: string]: ChatHistory[];
    currentChat?: any;
}

const initialState: ChatHistoryState = {

};

const chatHistorySlice = createSlice({
    name: 'chatHistory',
    initialState,
    reducers: {
        setChatHistory: (state, action: PayloadAction<{ chatHistory: ChatHistory[] }>) => {
            action.payload.chatHistory.forEach((history: ChatHistory) => {
                const chatId: string = history.chatId;
                if (state[chatId]) {
                    state[chatId] = [...state[chatId], history];
                } else {
                    state[chatId] = [history];
                }
            })
        },
        resetChatHistory: (state, action: PayloadAction<{ chatId: string }>) => {
            const chatId: string = action.payload.chatId;
            state[chatId] = [];
        },
        setCurrentChat: (state, action: PayloadAction<{ message: any }>) => {
            if (state.currentChat) {
                state.currentChat = [...state.currentChat, action.payload.message];
            } else {
                state.currentChat = [action.payload.message];
            }

        },
        resetCurrentChat: (state) => {
            state.currentChat = undefined;
        }
    },
});

export const { setChatHistory, resetChatHistory, setCurrentChat, resetCurrentChat } = chatHistorySlice.actions;
export default chatHistorySlice.reducer;